import { isPeerStream } from "../config.js";
const ue = window.ue;
const ue4 = window.ue4;

/**
 * apiSend:前端发消息给UE
 * @param { String } funcName 对应方法名
 * @param { String } data  对应Parameters参数
 */
export function apiSend(funcName, data) {
  if (isPeerStream) {
    let jsonData = {
      Command: funcName,
      Parameters: JSON.stringify(data),
    };
    console.log(jsonData);
    window.ps.emitMessage(JSON.stringify(jsonData));
  } else {
    console.log(data);
    ue4(funcName, data);
  }
}

/**
 * apiReceive: 前端注册接收UE信息
 * @param { String } funcName 对应方法名
 * @param { callback } callback  回调处理方法
 */
export function apiReceive(funcName, callback) {
  if (isPeerStream && window.ps) {
    console.log("注册回调" + funcName)
    window.ps.addEventListener("message", (e) => {
      callback(JSON.parse(e.detail));
    });
  } else {
    ue.interface[funcName] = callback;
    console.log("注册" + funcName);
    console.log(ue.interface);
  }
}
